import React from "react";

import svg from "../../assets/images/icons/Form Controls/Click To Edit Label.svg";

export const ClickToEditIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Up"}
    />
);
